module.exports = __webpack_public_path__ + "static/img/ex03.090f2fdc.jpg";